import { useEffect, useRef, useState } from "react";
import bannerImage from "../../assets/images/banner-right.png";
import introPic from "../../assets/images/intro-pic.png";
import CountUp, { useCountUp } from "react-countup";
import $ from "jquery";
import CustomersList from "./CustomersList";
import ProductsList from "./ProductsList";
import { useSearchParams, useLocation } from "react-router-dom";

function Home(props: any) {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  useCountUp({ ref: "customerCounter", duration: 5, end: 100 });
  useCountUp({ ref: "countriesCounter", duration: 5, end: 20 });
  var aboutUsRef = useRef(null);

  useEffect(() => {
    if (searchParams.get("goto")) handleScroll(aboutUsRef);
  }, [location]);

  const handleScroll = (ref: any) => {
    window.scrollTo({
      top: ref != undefined ? (ref?.current as any).offsetTop : 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="banner">
        <div className="overlay">
          <div
            className="container banner-content home"
            style={{ position: "relative", zIndex: "2" }}
            // data-aos="fade-up"
            // data-aos-delay="10"
            // data-aos-duration="600"
          >
            <div className="row align-items-center  aos-animate">
              <div
                className="col-lg-6 col-sm-12"
                data-aos="slide-right"
                data-aos-delay="10"
              >
                <h1 style={{ textAlign: "center" }}>
                  {/* Redefining Workspaces with Intelligent Cloud Solutions */}
                  Empowering <br />
                  Microsoft Cloud
                </h1>
                <p></p>
              </div>
              <div
                className="col-lg-6 col-sm-12"
                data-aos="slide-left"
                data-aos-delay="10"
              >
                <img src={bannerImage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="intro">
        <div ref={aboutUsRef} id="about-us"></div>
        <div className="container">
          <div className="plus-wrap">
            <div className="plus-left">
              <h2
                data-max="100"
                data-min="120"
                data-delay="16"
                data-increment="3"
                id="customerCounter"
              >
                {/* {<CountUp end={100} />} */}
              </h2>
              <span>
                <span className="plus">+</span>Happy
                <br />
                Customers
              </span>
            </div>

            <div className="plus-left twnt">
              <h2
                data-max="20"
                data-min="100"
                data-delay="12"
                data-increment="3"
                id="countriesCounter"
              ></h2>
              <span>
                <span className="plus">+</span>
                From
                <br />
                Countries
              </span>
            </div>
          </div>
          <div className="intro-text"></div>
          <div className="row align-items-center aos-animate">
            <div
              className="col-lg-6 col-sm-12 text-lg-end mb-5 "
              data-aos="fade-right"
              data-aos-delay="20"
            >
              <img src={introPic} alt="" />
            </div>
            <div
              className="hp-intro-text col-lg-6 col-sm-12 "
              data-aos="fade-left"
              data-aos-delay="50"
            >
              <h4>We harness the power of </h4>
              <h2>Microsoft 365 & Azure</h2>
              <p>
                through our tailored products and services—enabling businesses
                to build cost-effective, user-friendly, and scalable cloud
                solutions
              </p>
              <p>
                A common challenge for many businesses is the reliance on
                multiple third-party vendors and tools to meet their Microsoft
                365-related needs.
              </p>
              <p style={{ color: "#4348bd" }}>
                Cloudlas eliminates these dependencies, giving you full control
                over your business operations within the Microsoft ecosystem.
              </p>
              {/* <h4>We leverage the capabilities of </h4>
              <h2>Microsoft 365 & Azure</h2>
              <p>
                with the products and services which makes the customers build
                cost effective and user friendly solutions on cloud platform.{" "}
              </p>
              <p>
                One of the major problems faced by the customers is the
                dependencies with multiple third party vendors and tools in
                order to satisfy their Microsoft 365 based business needs.{" "}
              </p>
              <p style={{ color: "#4348bd", fontWeight: "bold" }}>
                Cloudlas helps to evade these dependencies and have complete
                control over your business.
              </p> */}
            </div>
          </div>
        </div>
      </section>
      <div id="services"></div>
      <ProductsList />
      <CustomersList />
    </>
  );
}

export default Home;
